<div class="short-term-form">
    <form [formGroup]="form" class="space-y-4">
        <!-- Parking Zones Multi-Select -->
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Parking Zones</mat-label>
            <mat-select formControlName="availableForParkingZones" multiple>
                @for (zone of availableZones(); track zone.id) {
                <mat-option [value]="zone.id">
                    <div class="flex items-center gap-2">
                        <mat-icon class="text-base text-purple-600">location_on</mat-icon>
                        <span>{{ zone.name }}</span>
                    </div>
                </mat-option>
                }
            </mat-select>
            <mat-hint>Optional: the zones that sell short-term. Leave empty for the whole space.</mat-hint>
        </mat-form-field>

        <!-- Availability Period -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Available From</mat-label>
                <input matInput [matDatepicker]="fromPicker" formControlName="availableFrom">
                <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
                <mat-hint>Optional: Leave empty for immediate availability</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Available To</mat-label>
                <input matInput [matDatepicker]="toPicker" formControlName="availableTo">
                <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
                <mat-datepicker #toPicker></mat-datepicker>
                <mat-hint>Optional: Leave empty for no end date</mat-hint>
            </mat-form-field>
        </div>

        <!-- Info Box -->
        <div class="bg-purple-50 border border-purple-200 rounded-lg p-3">
            <div class="flex items-start gap-2">
                <mat-icon class="text-purple-600 text-sm">info</mat-icon>
                <div class="text-sm text-purple-800">
                    <p><strong>Short-Term:</strong> Creates a short-term parking type for this space. Visitors
                        without a registered parking right are admitted and billed per the short-term tariff.</p>
                </div>
            </div>
        </div>
    </form>
</div>
